// import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  header: {
    [LanguagesEnum.English]: 'VAT Return Period Details',
    [LanguagesEnum.Greek]: 'VAT Return Period Details',
  },
  vat_return_period_control: {
    [LanguagesEnum.English]: 'VAT Return Period',
    [LanguagesEnum.Greek]: 'VAT Return Period',
  },
  vat_return_submission_date_control: {
    [LanguagesEnum.English]: 'VAT Return Submission Date',
    [LanguagesEnum.Greek]: 'VAT Return Submission Date',
  },
  vat_return_version_control: {
    [LanguagesEnum.English]: 'VAT Return Version',
    [LanguagesEnum.Greek]: 'VAT Return Version',
  },
  vat_return_year_control: {
    [LanguagesEnum.English]: 'VAT Return Year',
    [LanguagesEnum.Greek]: 'VAT Return Year',
  },
  start_date_control: {
    [LanguagesEnum.English]: 'Start Date',
    [LanguagesEnum.Greek]: 'Start Date',
  },
  end_date_control: {
    [LanguagesEnum.English]: 'End Date',
    [LanguagesEnum.Greek]: 'End Date',
  },
  note1: {
    [LanguagesEnum.English]:
      'Please fill the below fields only if you have changed Member State of Identification within the reporting period.',
    [LanguagesEnum.Greek]:
      'Please fill the below fields only if you have changed Member State of Identification within the reporting period.',
  },
  note2: {
    [LanguagesEnum.English]:
      'In this case you should fill two OSS VAT returns, one from the beginning of the period till the date of change in identification (to the originating Member state) and one from the date of change in identification till the end of the reporting period (to the Member state of Destination).',
    [LanguagesEnum.Greek]:
      'In this case you should fill two OSS VAT returns, one from the beginning of the period till the date of change in identification (to the originating Member state) and one from the date of change in identification till the end of the reporting period (to the Member state of Destination).',
  },
};

export default CONFIGURATION;
